var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUnhide(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 11,
    viewBox: "0 0 16 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.00001 2.55777C6.58741 2.55777 5.44223 3.70295 5.44223 5.11555C5.44223 6.52815 6.58741 7.67333 8.00001 7.67333C9.41261 7.67333 10.5578 6.52815 10.5578 5.11555C10.5578 3.70295 9.41261 2.55777 8.00001 2.55777ZM6.72112 5.11555C6.72112 4.40922 7.29368 3.83666 8.00001 3.83666C8.70634 3.83666 9.2789 4.40922 9.2789 5.11555C9.2789 5.82188 8.70634 6.39444 8.00001 6.39444C7.29368 6.39444 6.72112 5.82188 6.72112 5.11555Z",
    fill: "#333333"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 0C4.06559 0 1.55423 2.45528 0.458976 3.82215C-0.152992 4.58591 -0.152992 5.64521 0.458976 6.40896C1.55423 7.77584 4.06559 10.2311 8 10.2311C11.9344 10.2311 14.4458 7.77584 15.541 6.40896C16.153 5.64521 16.153 4.58591 15.541 3.82215C14.4458 2.45528 11.9344 0 8 0ZM1.45701 4.62184C2.45464 3.37678 4.63793 1.27889 8 1.27889C11.3621 1.27889 13.5454 3.37678 14.543 4.62184C14.7805 4.91829 14.7805 5.31283 14.543 5.60927C13.5454 6.85434 11.3621 8.95222 8 8.95222C4.63793 8.95222 2.45464 6.85434 1.45701 5.60927C1.21951 5.31283 1.21951 4.91829 1.45701 4.62184Z",
    fill: "#333333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnhide);
export default __webpack_public_path__ + "static/media/unhide.a77b9573ac7014c7fc3f6add9a738ae9.svg";
export { ForwardRef as ReactComponent };